import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { AppTextService } from '@fi-shared/app-text';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiValuesComparison } from '@fi-shared/utils/fi-values-comparison';
import { Subject } from 'rxjs';

export interface ISaveFilterDialogData {
    filterName: string;
    description?: string;
    label?: string;
    hint?: string;
}

@Component({
    selector: 'fi-items-list-save-filter-dialog',
    templateUrl: './fi-items-list-save-filter-dialog.component.html',
    styleUrls: ['./fi-items-list-save-filter-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-items-list-save-filter-dialog' },
    standalone: false,
})
export class FiItemsListSaveFilterDialogComponent
    extends FiDialogsContentBase<ISaveFilterDialogData, string>
    implements OnInit, OnDestroy
{
    private fiValuesComparison: FiValuesComparison<string>;

    ngOnInit() {
        this.setServices();
        this.fiValuesComparison = new FiValuesComparison(() => this.data.filterName);
        this.subscribeOnTransitionCloseDialog(this.fiDialogsService, this.ngOnDestroy$);
    }

    getLabel(): string {
        return !!this.data.label ? this.data.label : this.appTextService.get('filter.filter_name');
    }

    getHint(): string {
        return !!this.data.hint ? this.data.hint : this.appTextService.get('filter.save_name_input_hint');
    }

    isYesButtonDisabled(): boolean {
        return !this.data.filterName;
    }

    getResult(): string {
        return this.data.filterName;
    }

    getNoButtonClickPromise(): Promise<{ canClose: boolean }> {
        return this.fiDialogsService.getCanCloseConfirmation(!this.fiValuesComparison.isChanged());
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    private appTextService: AppTextService;
    private fiDialogsService: FiDialogsService;

    private setServices() {
        this.appTextService = this.injector.get(AppTextService);
        this.fiDialogsService = this.injector.get(FiDialogsService);
    }
}
